import useTextFormatter from "./useTextFormatter";

export default function useDynamicFontFormatter(fontStyle) {
  const { toLower, toUpper, toCamel } = useTextFormatter();

  const formatter =
    fontStyle?.toLowerCase() === "lower"
      ? toLower
      : fontStyle?.toLowerCase() === "upper"
      ? toUpper
      : fontStyle?.toLowerCase() === "camel"
      ? toCamel
      : (value) => value;

  return (value) => {
    if (!value) return value;

    // Split string into tokens separated by spaces
    return value
      .split(" ")
      .map((segment) => {
        // If segment contains NO letters (only digits/symbols) → return as is
        if (!/[a-zA-Z]/.test(segment)) {
          return segment;
        }

        // Else apply formatting on this part
        return formatter(segment);
      })
      .join(" ");
  };
}
